import React from 'react'

export default function Pagination(props) {
  return (
    <div className='flex items-center justify-center py-10'>
    <button className='py-[9px] px-2 bg-white text-secondary border border-secondary' onClick={props.handlePrevPage} disabled={props.currentPage === 1}>
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" fill="rgba(0,0,0,1)"></path></svg>
    </button>
    <span className='pagination-btn m-0'>{props.pageNumbers}</span>
    <button className='py-[9px] px-2 bg-white text-secondary border border-secondary ' onClick={props.handleNextPage} disabled={props.currentPage === props.totalPages}>
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="rgba(0,0,0,1)"></path></svg>
    </button>
  </div>
  )
}